import * as ng from 'angular';

export const StSelectRowCustom = () => (<angular.IDirective>{

    restrict: 'A',
    require: ['^stTable', 'stSelectRowCustom'],
    scope: {
        item: '=stSelectRowCustom'
    },

    link: (scope: any, element: JQLite, attr: any, ctrl: any) => {
        let mode = attr.stSelectMode || 'single';
        let lastSelected;
        let isSingleClick = true;

        //                var getObjectById = function (items, id) {
        //                    var item;
        //                    items.filter(function (i) {
        //                        if (i._id === id) {
        //                            item = i;
        //                        }
        //                    });
        //
        //                    return item;
        //                };

        let getIndexOfItem = (items, item) => {
            items.filter((key, it) => {
                if (item.id === it.id) {
                    return key;
                }
            });
        };

        let isSelectedUp = (items, currentItemSelected) => {
            let currentItemSelectedIndex = items.indexOf(scope.item);

            for (let i = 0, length = items.length; i < length; i++) {
                if (items[i].isSelected) {
                    return currentItemSelectedIndex < i;
                }
            }
        };

        let getFirstSelectedItemIndex = (items: any, isUp?: any) => {
            if (!isUp) {
                for (let i = 0, length = items.length; i < length; i++) {
                    if (items[i].isSelected) {
                        return i;
                    }
                }
            } else {
                let index;

                for (let i = 0, length = items.length; i < length; i++) {
                    if (items[i].isSelected) {
                        index = i;
                    }
                }

                return index;
            }
        };

        element.bind('click', ($event) => {
            let items = scope.$parent.items;
            let vm = this;

            scope.$apply(() => {
                if ($event.ctrlKey || $event.metaKey) {
                    ctrl[0].select(scope.item, mode);
                    scope.lastSelected = ng.copy(scope.item);
                } else if ($event.shiftKey) {
                    if (scope.$parent.selectedItems.length > 0) {
                        let selectFromIndex;

                        if (scope.$parent.selectedItems.length > 1) {
                            let isUp = isSelectedUp(items, scope.item);
                            selectFromIndex = getFirstSelectedItemIndex(items, isUp);
                            scope.$parent.clearSelection();
                        }

                        let firstSelectedIndex = selectFromIndex !== undefined ? selectFromIndex : getFirstSelectedItemIndex(items);
                        let selectedElementIndex = items.indexOf(scope.item);

                        if (scope.lastSelected) {
                            //                                var lastSelectedIndex = items.indexOf(scope.lastSelected);
                            //
                            //                                if (lastSelectedIndex < selectedElementIndex) {
                            //                                    firstSelectedIndex = lastSelectedIndex;
                            //                                }
                        }

                        let selectToIndex;

                        if (firstSelectedIndex < selectedElementIndex) {
                            selectFromIndex = firstSelectedIndex;
                            selectToIndex = selectedElementIndex;
                        } else {
                            selectFromIndex = selectedElementIndex;
                            selectToIndex = firstSelectedIndex;
                        }

                        for (let i = selectFromIndex; i <= selectToIndex; i++) {
                            ctrl[0].select(items[i], mode);
                            scope.$parent.addOrRemoveSelectedItems(items[i]);
                        }

                        if (!items[firstSelectedIndex].isSelected) {
                            ctrl[0].select(items[firstSelectedIndex], mode);
                            scope.$parent.addOrRemoveSelectedItems(items[firstSelectedIndex]);
                        }
                    } else {
                        ctrl[0].select(scope.item, 'single');
                    }
                } else {
                    if (items.length > 0) {
                        if (scope.$parent.selectedItems.length > 0) {
                            if (scope.$parent.selectedItems.length === 1) {
                                if (!scope.item.isSelected) {
                                    scope.$parent.clearSelection();
                                }
                            } else {
                                scope.$parent.clearSelection();
                            }
                        }
                    }

                    if (!scope.item.isSelected) {
                        ctrl[0].select(scope.item, 'single');
                    }
                    //                            scope.lastSelected = angular.copy(scope.item);
                    //                            ctrl[1].updateLastSelected();
                }
            });
        });

        element.bind('dblclick', () => {
            let showModal = false;
            isSingleClick = false;
            let type = 'pdf';

            setTimeout(() => {
                isSingleClick = true;

                if (scope.item.content_type === 'application/x-www-form-urlencoded;charset=UTF-8') {
                    return;
                }

                if (scope.item.content_type !== undefined) {
                    if (scope.item.content_type === 'application/pdf' || scope.item.content_type.indexOf('image/') !== -1) {
                        type = scope.item.content_type === 'application/pdf' ? 'pdf' : 'img';
                        showModal = true;
                    }
                } else {
                    if (scope.item.fileName !== undefined || scope.item.filePathPDF !== undefined || scope.item.file_path_pdf) {
                        var extension = scope.item.fileName !== undefined ?
                            scope.item.fileName.split('.').pop()
                            : (scope.item.filePathPDF !== undefined) ? scope.item.filePathPDF.split('.').pop() : scope.item.file_path_pdf.split('.').pop();

                        if (extension === 'pdf' || extension === 'jpg' || extension === 'jpeg' || extension === 'png') {
                            type = extension === 'pdf' ? 'pdf' : 'img';
                            showModal = true;
                        }
                    }
                }

                if (showModal) {
                    scope.$parent.previewModal(scope.item, type);
                }
                //                        return;
            }, 500);
        });

        scope.$watch('item.isSelected', (newValue) => {
            if (newValue === true) {
                element.addClass('st-selected');
            } else {
                element.removeClass('st-selected');
            }
        });
    },
    controller: ($scope) => {
        // ?
    }
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/third/smart-table/st-select-row-custom/st-select-row-custom.directive.ts